export const NEW_IOSS_FILE_TYPE_ALL = 'NEW_FILE_TYPE_ALL';
export const NEW_IOSS_FILE_TYPE_WITH_PAYMENT = 'NEW_FILE_TYPE_WITH_PAYMENT';
export const NEW_NON_UNION_FILE_TYPE_ALL = 'NEW_NON_UNION_FILE_TYPE_ALL';
export const NEW_NON_UNION_FILE_TYPE_WITH_PAYMENT = 'NEW_NON_UNION_FILE_TYPE_WITH_PAYMENT';
export const NEW_NON_UNION_XML_FILE_TYPE_ALL = 'NEW_NON_UNION_XML_FILE_TYPE_ALL';
export const NEW_NON_UNION_XML_FILE_TYPE_WITH_PAYMENT = 'NEW_NON_UNION_XML_FILE_TYPE_WITH_PAYMENT';
export const NEW_UNION_FILE_TYPE_ALL = 'NEW_UNION_FILE_TYPE_ALL';
export const NEW_UNION_FILE_TYPE_WITH_PAYMENT = 'NEW_UNION_FILE_TYPE_WITH_PAYMENT';

export const NEW_SWISS_POST_FILE = 'NEW_SWISS_POST_FILE';
